import { useCharactersStore } from '@/features/shared/stores/characters.store'
import { Collapsible } from '@/shared/components/ui/collapsible'
import {
    Sidebar,
    SidebarContent
} from '@/shared/components/ui/sidebar'
import { Users } from 'lucide-react'
import * as React from 'react'

export default function ChOptionBar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { characters } = useCharactersStore()

    return (
        <Sidebar
            collapsible="none"
            className="sticky top-0 hidden h-svh border-l lg:flex"
            side="right"
            {...props}
        >
            <SidebarContent>
                <div className="p-4 border-b">
                    <h2 className="text-sm font-semibold flex items-center gap-2">
                        <Users className="w-4 h-4" />
                        Character Stats
                    </h2>
                    <p className="text-xs text-muted-foreground mt-1">
                        Total Characters: {characters.length}
                    </p>
                </div>

                <Collapsible
                    defaultOpen={true}
                    className="group/collapsible flex flex-col pt-4"
                >

                </Collapsible>
            </SidebarContent>
        </Sidebar>
    )
}
